import React, { Component } from 'react';
import injectSheet from 'react-jss';
import { Subscribe } from 'unstated';
import faker from 'faker';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import HeaderPage from './HeaderPage';
import StartSessionContainer from '../containers/StartSessionContainer';
import ParticipantsCard from '../components/ParticipantsCard';
import CountDownCard from '../components/CountDownCard';
import DescriptiveCard from '../components/DescriptiveCard';
import DraftParentsGroup from '../components/DraftParentsGroup';
import session from '../models/Session';
import _ from 'lodash'; 
import { Redirect } from 'react-router-dom';

const styles = {
  promptCardWrapper: {
    margin: '0 auto',
    width: '37.5rem',
  },
};

const GET_DRAFT_BY_ID = id => gql`
  query {
    draftWithParents(_id: "${id}") {
      _id
      title,
      blurb,
      image,
      createdAt, 
      createdBy {
        displayName 
        _id 
        image 
      }
      participants {
        displayName,
        image,
        _id
      },
     parents {
      image
      parentType
      prompt
      _id
      blurb
      title
      name
      }
      sessions {
        index,
        _id
        fields
      }
      template {
        _id,
        name,
        slug,
        sessions {
          description,
          minutes,
          points,
          index,
          _id,
          output {
            name,
            slug,
            type,
            _id
          }
        }
      }
    }
  }
`;

class StartSessionPage extends Component {
  componentDidMount() {
    if (this.props.startSession) {
      this.props.startSession.setup(this.props);
    }
  }

  componentWillUnmount() {
    this.props.startSession.destroy();
  }

  render() {
    const { classes, startSession } = this.props;

    // if (!(startSession.state.draftSessions && startSession.state.draft && startSession.state.draftSessions.current)) {
    //   return null;
    // }

    return (
      <Query query={GET_DRAFT_BY_ID(this.props.match.params.id)}>
        {({ loading, error, data }) => {
          if (loading) return <div>Loading...</div>;
          if (error) return <div>Error :(</div>;
          let { match: { params: { number, id } } } = this.props;
          number = parseInt(number);
          const currentSession = data.draftWithParents.template.sessions[number - 1];
          currentSession.index = number - 1;
          currentSession.draftId = id;

          // console.log('data', data, currentSession );

          if (data.draftWithParents.createdBy._id !== session.getUser()._id && !_.some(data.draftWithParents.participants, { _id: session.getUser()._id })) {
            return ( <Redirect to="/" /> );
          } 

          startSession.startDraftSession(currentSession, data.draftWithParents);
          // console.log('startSession.state.isShowing', startSession.state.isShowing)

          /*console.log('Starting current session', {
            currentSession,
            currentState: startSession.state
          }) */

          return (
            <div>
              <HeaderPage titleHeader={`Session ${number}`} descriptionHeader={currentSession.description} showBtns={false} />
              <div className={classes.promptCardWrapper}>
                <CountDownCard start={Math.abs(Date.now() - ((currentSession.minutes * 60 * 1000) || 20 * 60 * 1000) - startSession.state.createdAt)} showBtn={startSession.state.leader && startSession.state.isComplete} to={`/crew/${id}/${number}/end`} />
                <ParticipantsCard participants={[data.draftWithParents.createdBy].concat(data.draftWithParents.participants)} />
                <DraftParentsGroup
                  session={startSession.state.draftSession}
                  values={startSession.state.fields}
                  draft={data.draftWithParents}
                  participantBtn
                  onChange={startSession.handleOnChange}
                  onClick={startSession.handleShowParticipantToggle}
                  btnHidden={!startSession.state.leader}
                  leader={startSession.state.leader}
                  isHidden={startSession.state.isHidden}
                  isShowing={startSession.state.isShowing} // TODO: this is decrecated
                />
              </div>
            </div>
          );
        }}
      </Query>
    );
  }
}

function StartSessionPageWrapper(props) {
  const { classes } = props;

  return (
    <Subscribe to={[StartSessionContainer]}>
      { startSession => (
        <div>
          {startSession && (
            <StartSessionPage {...props} classes={classes} startSession={startSession} />
          )}
        </div>
      )}
    </Subscribe>
  );
}

export default injectSheet(styles)(StartSessionPageWrapper);



// WEBPACK FOOTER //
// ./src/pages/StartSessionPage.js